import * as React from "react";

export type GoalTableProps = {
	cpCorrectionValue: number;
};

export const CPCorrectionValueTable = React.memo((props: GoalTableProps) => {
	const { cpCorrectionValue } = props;
	return (
		<table className={"correct-table"} style={{ width: "20%", display: "inline-table", marginLeft: "10%" }}>
			<thead>
				<tr>
					<th>実績補正係数</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>{cpCorrectionValue.toFixed(1)}</td>
				</tr>
			</tbody>
		</table>
	);
});
